import React, { useRef, useState } from "react";
import "../footer.css";

const HomePageUpperFooter = ({ data }) => {
  const {
    connect_heading,
    content_bg_color,
    email_input,
    social_icons,
    subscribe_cta,
    subscribe_title,
    title_color,
  } = data.connect_and_subscribe || {};

  const [email, setEmail] = useState("");
  const emailRef = useRef();
  const api = "/dial-api/subscribe";

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (!isValidEmail(email)) {
      emailRef.current.style.border = "2px solid red";
      alert("Please enter valid email");
      return;
    }
    emailRef.current.style.border = "";
    subscribe();
  };

  const isValidEmail = (email) => {
    if (typeof email !== "string") return false;
    const value = email.trim();
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
    return re.test(value);
  };

  const subscribe = async () => {
    try {
      let response = await fetch(api, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: email,
        }),
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      let result = await response.json();
      setEmail("");
      alert(result.message);
    } catch (err) {
      console.error("Subscription error:", err);
    }
  };

  return (
    <section
      className="py-[3vh] xl:py-[6vh]"
      style={{ backgroundColor: content_bg_color }}
    >
      <div className="container flex flex-col lg:flex-row lg:gap-[3vw] gap-[5vw] justify-between items-start xl:items-center lowerFooterSec">
        <div className="lg:w-[50%] text-white font-redhatRegular lg:text-[1.1vw] text-[4vw]">
          <p>
            Name:{" "}
            <strong className="font-redhatBold">
              Delhi International Airport Limited (DIAL)
            </strong>
          </p>
          <p className="lg:w-[80%]">
            Registered Office: New Udaan Bhawan, Opposite Terminal - 3, Indira
            Gandhi International Airport, New Delhi - 110037
          </p>
          <p>CIN: U63033DL2006PLC146936</p>
          <p>
            T: <a href="tel:+911147197000">+91-11-47197000</a> / F:{" "}
            <a href="tel:+911147197181">+91-11-4719 7181</a>
          </p>
          <p className="lg:pt-[0.5vw] pt-[2vw]">
            Contact Person:{" "}
            <strong className="font-redhatBold">Mr. Sushil Dudeja</strong>
          </p>
          <p>
            Email id:{" "}
            <strong className="font-redhatBold">
              <a href="mailto:dial-cs@gmrgroup.in">dial-cs@gmrgroup.in</a>
            </strong>
          </p>
          <p className="lg:pt-[0.5vw] pt-[2vw]">
            *For assistance with travel-related queries,
          </p>
          <p>
            please write to{" "}
            <strong className="font-redhatBold">
              <a href="mailto:feedback.igiairport@gmrgroup.in">
                feedback.igiairport@gmrgroup.in
              </a>
            </strong>
          </p>
        </div>
        <div className="lg:w-[50%]">
          {/* Left side: Social & heading */}
          <div className="flex flex-col lg:flex-row gap-[2vh] xl:gap-[3vh] socialSec lg:pb-[1vw]">
            <h2 className="text-white text-[3vh] xl:text-[4vh] font-redhatMedium">
              {connect_heading}
            </h2>
            <div className="flex flex-wrap gap-[3vh] xl:gap-[4vh] items-center">
              {social_icons?.map((item, index) => (
                <a
                  key={index}
                  href={item.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-[3vh] xl:w-[5vh] h-[3vh] xl:h-[5vh] flex items-center justify-center"
                >
                  <img
                    src={item.icon.url}
                    alt={item.icon.alternativeText}
                    className="w-full h-full object-contain"
                  />
                </a>
              ))}
            </div>
          </div>

          {/* Right side: Subscription Form */}
          <div className="flex flex-col xl:gap-[3vh] w-full subscribeSec lg:py-0 py-[3vw]">
            <h3
              className="font-redhatMedium text-[3vh] xl:text-[5vh] subscribeText lg:pb-0 pb-[1vw]"
              style={{ color: title_color }}
            >
              {subscribe_title}
            </h3>
            <form
              className="flex w-full rounded-[2vh] font-redhatRegular overflow-hidden formSec"
              onSubmit={handleSubscribe}
              ref={emailRef}
            >
              <input
                type={email_input?.input_type || "text"}
                value={email}
                placeholder={email_input?.placeholder}
                aria-label={email_input?.placeholder || "Email address"}
                className="flex-1 px-[2vh] py-[1vh] text-[2vh] xl:text-[3vh] h-[6vh] xl:h-[8vh] emailInput"
                style={{
                  backgroundColor: email_input?.bg_color,
                }}
                onChange={(e) => setEmail(e.target.value)}
              />
              {/* {error && <p className="text-red-500 text-sm">{error}</p>} */}
              <button
                type="submit"
                className="px-[2vh] py-[1vh] text-[2vh]  h-[6vh] xl:h-auto xl:text-[3vh] font-semibold subscribeBtn"
                style={{
                  backgroundColor: subscribe_cta?.bg_color,
                  color: "#002C62",
                }}
              >
                {subscribe_cta?.label}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomePageUpperFooter;
